// Iter 587 (Kamel — sécurité) : l'administration n'est plus sur /admin mais sur une adresse secrète.
// Même valeur côté backend : utils/site.py → ADMIN_PATH (liens e-mails, push, lien magique).
export const ADMIN_PATH = '/@Tintin69800';
export const ADMIN_PATH_ALIAS = '/Tintin69800';
export const adminUrl = (suffix = '') => `${ADMIN_PATH}${suffix}`;
